import { Formik } from "formik";
import * as Yup from "yup";
import {
  BasicSettingsFormValueType,
  useBasicSettingsFormSubmit,
} from "../../hooks/settings/useBasicSettingsFormSubmit";
import {
  TransformedBasicSettings,
  useBasicSettings,
} from "../../hooks/settings/useBasicSettings";
import { DisplayBasicSettingsForm } from "./DisplayBasicSettingsForm";
import { useDefaultSettings } from "../../hooks/settings/useDefaultSettings";
import { DirtyFormPrompt } from "../form/DirtyFormPrompt";
import { HeaderSaveFormButton } from "melco-shared-logic";

const BasicSettingsSchema = Yup.object().shape({
  measurement_unit: Yup.string().required(),
  embroidery_output_format: Yup.array().required(),
  enable_debug: Yup.bool().required(),
  enable_folder_grouping: Yup.bool().required(),
});

const basicSettingsToInitialValues = (
  settings: TransformedBasicSettings
): BasicSettingsFormValueType => {
  const {
    embroidery_output_format,
    print_output_format,
    enable_debug,
    enable_folder_grouping,
    measurement_unit,
  } = settings;
  const initialEmbroideryOutputFormatValues = (
    embroidery_output_format ?? []
  ).map((value) => value.extension ?? "");
  const initialPrintOutputFormatValues = (print_output_format ?? []).map(
    (value) => value.extension ?? ""
  );
  return {
    embroidery_output_format: initialEmbroideryOutputFormatValues,
    print_output_format: initialPrintOutputFormatValues,
    enable_debug,
    enable_folder_grouping,
    measurement_unit,
  };
};

export const BasicSettingsForm: React.FC = () => {
  const { settings, isLoading } = useBasicSettings();
  const { defaultSettings, isLoading: isDefaultSettingsLoading } =
    useDefaultSettings();
  const onSubmit = useBasicSettingsFormSubmit();

  if (isLoading || !settings || isDefaultSettingsLoading || !defaultSettings) {
    return null;
  }

  return (
    <Formik
      initialValues={basicSettingsToInitialValues(settings)}
      validationSchema={BasicSettingsSchema}
      onSubmit={onSubmit}
    >
      <DirtyFormPrompt>
        <DisplayBasicSettingsForm defaultSettings={defaultSettings} />
        <HeaderSaveFormButton />
      </DirtyFormPrompt>
    </Formik>
  );
};
